module.exports = __webpack_public_path__ + "static/media/user-38.808a1c54.png";